/**
 * @param   {object} state
 *
 * @returns {number}
 */
const getProcessedInvitations = state => state.processedInvitations

/**
 * @param   {object} state
 *
 * @returns {number}
 */
const getProgressInvitationsPercentage = state =>
  state.totalInvitations
    ? Math.round((state.processedInvitations / state.totalInvitations) * 100)
    : 0

/**
 * @param   {object} state
 *
 * @returns {number}
 */
const getTotalInvitations = state => state.totalInvitations

/**
 * @param   {object} state
 *
 * @returns {Array}
 */
const getFailedInvitationEmails = state => state.failedInvitationsEmails

/**
 * @param   {object} state
 *
 * @returns {Array}
 */
const getUsers = state => state.users

/**
 * @param   {object} state
 *
 * @returns {Array}
 */
const getAllUsers = state => state.allUsers

/**
 * @param   {object} state
 *
 * @returns {number}
 */
const getUsersCount = state => state.usersCount

/**
 * @param   {object} state
 *
 * @returns {Array}
 */
const getMentionableUsers = state => state.mentionableUsers

/**
 * @param   {object} state
 *
 * @returns {Array}
 */
const getUsersByTeam = state => state.usersByTeam

/**
 * @param   {object} state
 *
 * @returns {number}
 */
const getUsersByTeamCount = state => state.usersByTeamCount

/**
 * @param   {object} state
 *
 * @returns {number}
 */
const getUsersByVendorCount = state => state.usersByVendorCount

/**
 * @param   {object} state
 *
 * @returns {number}
 */
const getLimit = state => state.limit

/**
 * @param   {object} state
 *
 * @returns {Array}
 */
const getTeams = state => state.teams

/**
 * @param   {object} state
 *
 * @returns {Array}
 */
const getVendors = state => state.vendors

/**
 *
 * @param   {object} state
 * @returns {Array}
 */
const getResponsibleProductUsers = state => state.responsibleProductUsers

/**
 * @param   {object} state
 *
 * @returns {object}
 */
const getActiveVendor = state => state.activeVendor

/**
 * @param   {object} state
 *
 * @returns {Array}
 */
const getRegistrations = state => state.registrations

/**
 * @param   {object} state
 *
 * @returns {Array}
 */
const getUsersByVendor = state => state.usersByVendor

/**
 * @param   {object} state
 *
 * @returns {number}
 */
const getRegistrationsCount = state => state.registrationsCount

const getters = {
  getProcessedInvitations,
  getProgressInvitationsPercentage,
  getTotalInvitations,
  getFailedInvitationEmails,
  getUsers,
  getAllUsers,
  getUsersCount,
  getTeams,
  getVendors,
  getActiveVendor,
  getUsersByTeam,
  getUsersByVendor,
  getLimit,
  getUsersByTeamCount,
  getUsersByVendorCount,
  getMentionableUsers,
  getRegistrationsCount,
  getRegistrations,
  getResponsibleProductUsers
}

export default getters
